<template>
  
  <!-- 
    <chat :error="error" :quote="quote">
      <template #messages></template>
      <template #files></template>
      <template #reply></template>
      <template #input></template>
    </chat>  
  -->


        <!-- chat container -->
         <div class="column container" :style="{width, height}">

              <!-- messages -->              
              <div class="column messageBox" ref="chat">                          
                <div class="column messageList">
                  <slot name="messages"></slot>
                </div>   
              </div>

                <!-- inputbox -->
                <div class="column inputBox">

                  <!-- files -->
                   <div class="row ch wrap debug">                    
                      <slot name="files"></slot>
                   </div>
                   
                   <!-- error -->
                   <p v-if="error" ref="error">{{ error }}</p>

                   <!-- reply -->
                    <div ref="reply">
                      <slot name="reply"></slot>
                    </div>
                  
                  <!-- input -->     
                   <div ref="reply">
                    <slot name="input"></slot>
                  </div>             
                </div>            
              
              

              <!-- inputs -->
              <div v-if="false" class="column inputBox">
                  
                <!-- files -->
                  <div class="row ch wrap" v-if="files.length" style="padding: 6px 10px 0">
                    <p class="tag" @click="showfile(file)" style="padding-right: 6px;" :title="`${file.name}\n\n${tools.filesize(file.size)}`" v-for="(file, index) in files" :key="index">
                      <!-- <span>
                        <img style="max-height: 16px; width: auto;" :src="`/images/icons/file/${(tools.ext(file.name) || 'txt').toUpperCase()}.svg`">
                      </span> -->
                      📄 {{ tools.cut(file.name, 15) }} 
                      <span class="tag delete" @click.prevent="tools.push(files,file)"></span> 
                    </p>
                    <p class="tag" v-upload="appendFiles">+Add files</p>
                  </div>

                  <!-- error -->
                  <p v-if="error" title="Click to remove error">{{ error }}</p>

                  <!-- reply -->
                  <div class="row" v-if="message.reply" style="justify-content: space-between; width: 100%;  padding: 8px 10px 5px">
                    <div class="row" style="width: 100%;">
                      <div class="column" style="margin-right: 16px; margin-top: 4px;">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 9.15L7.43745 1.5V5.75C17.5761 5.75 18.7457 13.9763 18.4641 18.5C18.0383 16.2178 17.8407 12.55 7.43745 12.55V16.8L1.5 9.15Z" stroke="#057AFF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </div>
                      <div class="column">
                        <p class="demi">Reply to {{ message.meta ? message.meta.replyName : '' }}</p>
                        <p @click="at(`msg${message.reply}`)" class="desc" :title="message.meta ? message.meta.replyText : ''">{{ tools.cut( message.meta ? message.meta.replyText : '', 50)}}</p>
                      </div>
                    </div>
                    <div class="column ch pointer click hover" @click="deleteReply()" style="width: 24px; height: 24px; font-size: 18px; line-height: 18px; border-radius: 100px;">×</div>                    
                  </div>

                  <!-- input container -->             
                  <div class="row ch" style="position: relative; align-items: flex-end;">
                    
                        <!-- upload icon -->
                        <div v-upload="appendFiles" class="column pointer click center" style="width: 60px; height: 60px;">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2127 9.78701C12.8979 9.47209 12.5242 9.22228 12.1128 9.05185C11.7014 8.88141 11.2605 8.79369 10.8152 8.79369C10.3699 8.79369 9.92903 8.88141 9.51766 9.05185C9.10629 9.22228 8.73253 9.47209 8.41772 9.78701L4.99272 13.213C4.357 13.8489 3.99991 14.7112 4 15.6104C4.00009 16.5095 4.35737 17.3718 4.99322 18.0075C5.62908 18.6432 6.49143 19.0003 7.39058 19.0002C8.28972 19.0001 9.152 18.6429 9.78772 18.007L10.1087 17.703M9.78772 13.213C10.1025 13.5279 10.4763 13.7777 10.8877 13.9482C11.299 14.1186 11.7399 14.2063 12.1852 14.2063C12.6305 14.2063 13.0714 14.1186 13.4828 13.9482C13.8942 13.7777 14.2679 13.5279 14.5827 13.213L18.0067 9.78701C18.6426 9.15128 18.9999 8.289 18.9999 7.38986C19 6.49072 18.6429 5.62836 18.0072 4.99251C17.3715 4.35665 16.5092 3.99938 15.6101 3.99928C14.7109 3.99919 13.8486 4.35628 13.2127 4.99201L12.1847 5.95301" stroke="#666666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>                          
                        </div>
                              
                        <!-- input -->
                        <at-ta :members="teamlist" name-key="name" v-model="message.text" @insert="mention" style="width: 100%;">
                          <textarea ref="area" v-model="message.text" @input="checkEmptyArea" @keydown.enter.exact.prevent="''"  @keydown.enter.exact="send()" style="background-color: #1C1C1C; width: 100%; margin: 0;padding-left: 0;padding-right: 0; " placeholder="write message..." rows="1" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>                      
                        </at-ta>

                        <!-- <div class="row wrap pointer click center" style="width: 60px; height: 60px;">
                          <p class="tag more" style="margin: 0;"></p>
                        </div> -->
                        
                        <div v-if="!progress" :title="JSON.stringify(message)" @click="send()" class="row wrap pointer click center" style="width: 60px; height: 60px;">
                          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="13.0055" cy="13.0003" r="10.4" fill="#D9D9D9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1799 26 26 20.1799 26 13C26 5.8201 20.1799 0 13 0C5.8201 0 0 5.8201 0 13C0 20.1799 5.8201 26 13 26ZM13.0065 7.4854C12.7628 7.72919 12.6259 8.05979 12.6259 8.4045C12.6259 8.74921 12.7628 9.07981 13.0065 9.3236L15.3829 11.7H7.4841C7.13932 11.7 6.80866 11.837 6.56486 12.0808C6.32106 12.3246 6.1841 12.6552 6.1841 13C6.1841 13.3448 6.32106 13.6754 6.56486 13.9192C6.80866 14.163 7.13932 14.3 7.4841 14.3H15.3829L13.0065 16.6777C12.7697 16.9229 12.6387 17.2513 12.6416 17.5921C12.6446 17.933 12.7813 18.259 13.0223 18.5001C13.2634 18.7411 13.5894 18.8778 13.9303 18.8808C14.2711 18.8837 14.5995 18.7527 14.8447 18.5159L19.4402 13.9191C19.6839 13.6753 19.8208 13.3447 19.8208 13C19.8208 12.6553 19.6839 12.3247 19.4402 12.0809L14.846 7.4854C14.6022 7.24169 14.2716 7.10478 13.9269 7.10478C13.5822 7.10478 13.2503 7.24169 13.0065 7.4854Z" fill="#427EFF"/></svg>
                        </div>
                        <div v-else  class="row wrap pointer click center" style="width: 60px; height: 60px; opacity: .1;">
                          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="13.0055" cy="13.0003" r="10.4" fill="#D9D9D9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1799 26 26 20.1799 26 13C26 5.8201 20.1799 0 13 0C5.8201 0 0 5.8201 0 13C0 20.1799 5.8201 26 13 26ZM13.0065 7.4854C12.7628 7.72919 12.6259 8.05979 12.6259 8.4045C12.6259 8.74921 12.7628 9.07981 13.0065 9.3236L15.3829 11.7H7.4841C7.13932 11.7 6.80866 11.837 6.56486 12.0808C6.32106 12.3246 6.1841 12.6552 6.1841 13C6.1841 13.3448 6.32106 13.6754 6.56486 13.9192C6.80866 14.163 7.13932 14.3 7.4841 14.3H15.3829L13.0065 16.6777C12.7697 16.9229 12.6387 17.2513 12.6416 17.5921C12.6446 17.933 12.7813 18.259 13.0223 18.5001C13.2634 18.7411 13.5894 18.8778 13.9303 18.8808C14.2711 18.8837 14.5995 18.7527 14.8447 18.5159L19.4402 13.9191C19.6839 13.6753 19.8208 13.3447 19.8208 13C19.8208 12.6553 19.6839 12.3247 19.4402 12.0809L14.846 7.4854C14.6022 7.24169 14.2716 7.10478 13.9269 7.10478C13.5822 7.10478 13.2503 7.24169 13.0065 7.4854Z" fill="#427EFF"/></svg>
                        </div>

                        <!-- support team select popover -->
                        <div v-if="showMentionsPopup" class="column" style="position: absolute; top: -20px;  background-color: var(--g05); border-radius: 10px;">
                          <div class="row">
                            <p class="tag" v-for="(item, index) in db.supportTeam" :key="index">{{ item.name }}</p>
                          </div>
                        </div>

                  </div>

                  <!-- {{ teamlist }} -->
                  <!-- <br> -->
                  <!-- {{ message }} -->
                  
                </div>
            </div>



</template>
<script setup>
</script>
<script>
/* eslint-disable */
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {      
   const chat = this.$refs.chat
    chat.addEventListener('wheel', function(e) {
      e.preventDefault(); // Отменяем стандартный скролл
      chat.scrollTop -= e.deltaY; // Инвертируем направление скролла
    }, { passive: false });
  },  
  props:{
    width: {type:String, default:'380px'},
    height: {type:String, default:'90vh'},
    error: undefined,
    quote: undefined,
  },
  data() {
    return {    
     

    }
  },

  methods: {
    deleteReply(){
      this.$emit("deleteReply",true)
    }
  },
 
});

</script>
<style scoped>
.container{
   /* width: 380px;  */
   /* height: 100%;  */
   border-radius: 20px; 
   background-color: var(--g05);   
   overflow-y: scroll;
}
.messageBox{
  position: relative; 
  align-self: flex-end; 
  overflow-y: scroll; 
  width: 380px; 
  height: 100%; 
  /* padding: 0 8px; */
  transform: scale(1,-1); 
}
.messageList{
  padding: 15px; 
  padding-bottom: 60px; 
  transform: scale(1,1);
}
.inputBox{
  position: relative; 
  border-bottom-left-radius: 20px; 
  border-bottom-right-radius: 20px; 
  bottom: 0; 
  width: 100%;
  background-color: #1C1C1C;
}
</style>